import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { SpinProps } from 'antd/lib'
import { clsx } from 'shared/libs/style-merge'

import React from 'react'

import styles from './Loader.module.scss'

interface Props extends SpinProps {
  iconSize?: number
  iconColor?: string
  wrapperClassName?: string
}

export const Loader: React.FC<Props> = ({
  size = 'default',
  iconSize = 48,
  iconColor = '#01974B',
  wrapperClassName,
  ...props
}) => {
  return (
    <div className={clsx(styles.loader, wrapperClassName)}>
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: iconSize, color: iconColor }}
            spin
          />
        }
        className={styles.spin}
        size={size}
        {...props}
      />
    </div>
  )
}
// TODO взять из палитры
